import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MaterialRuleStore, MaterialRuleState } from './materialRule.store';
import { MaterialRule } from 'src/app/models/MaterialRule.model';

@Injectable({ providedIn: 'root' })
export class MaterialRuleQuery extends QueryEntity<MaterialRuleState> {
  constructor(protected override store: MaterialRuleStore) {
    super(store);
  }

  selectMaterialRulesByProductId(finalProductId: number) {
    return this.selectAll({
      filterBy: entity => entity.final_product_id === finalProductId
    });
  }
}
